import { Component, Host, Prop, h, State, Watch, Event, EventEmitter } from '@stencil/core';
import { DeviceType } from '../types';
import { PnLevelUpService } from '../pn-level-up.service';

@Component({
  tag: 'pn-level-up-modal',
  styleUrl: 'pn-level-up-modal.scss',
})

export class PnLevelUpModal {
  @Prop({ reflect: true }) open: boolean;
  @Prop() endpoint: string;
  @Prop() instructionPhoneLineOne: string;
  @Prop() instructionPhoneLineTwo: string;
  @Prop() instructionPhoneLineThree: string;
  @Prop() headingText: string;
  @Prop() outdatedQRMessage: string;
  @Prop() expiresInMessage: string;
  @Prop() system: DeviceType;
  @Prop() qrAriaLabel: string;

  @State() private openModalToggle: boolean = false;
  @State() private isLoading: boolean = true;
  @Event({ eventName: 'modalToggle', bubbles: true, composed: true }) modalToggle: EventEmitter<boolean>;

  private _bankIDUrl: string;
  private _levelupService: PnLevelUpService;
  private _levelUpModal: HTMLElement;

  componentWillLoad() {
    this._levelupService = new PnLevelUpService(this.endpoint);
    this.updateOpen();
  }

  private updateBankIDUrl = async () => {
    this.isLoading = true;
    let authResponse = await this._levelupService.levelupAuthorize(this.system, null);
    this.isLoading = false;
    this._bankIDUrl = authResponse.url;
    await this._levelupService.levelupTokenGrant(authResponse.id, '30', null).then((response) => {
      if (response.code === 200) {
        this._levelupService.newLevelupUser();
      }
    });
  }

  @Watch('open')
  updateOpen () {
    if (this.open === true) {
      this.handleOpen();
      this.openModalToggle = true;
      if (this._levelUpModal) {
        if ((this._levelUpModal as any).open === true) {
          (this._levelUpModal as any).open = false;
        }
        (this._levelUpModal as any).open = true;
      }
    }
    else {
      this.openModalToggle = false;
    }
  }

  private handleOpen = async () => {
    await this.updateBankIDUrl();
  }


  render() {
    return (
      <Host>
        <pn-modal
          ref={el => this._levelUpModal = el as HTMLElement}
          open={this.open}
          class="level-up-phone-modal"
          allow-overflow='true'
          label={this.headingText}
          onModalToggle={(ev: CustomEvent<boolean | { open: boolean }>) => {
            const detail = ev.detail as any;
            const isOpen = typeof detail === 'boolean' ? detail : !!detail?.open;
            this.openModalToggle = isOpen;
          }}>
          {this.isLoading ?
            (<pn-spinner light="false" size="1.5"></pn-spinner>) : (
              <div class="modal-content-container">
                <div class="modal-content-qr">
                  {this.openModalToggle && (
                    <pn-qr-code-generator
                      url={this._bankIDUrl}
                      countdown-seconds="30"
                      outdated-message={this.outdatedQRMessage}
                      expires-in-message={this.expiresInMessage}
                      update-code-every-second={true}
                      aria-label={this.qrAriaLabel}>
                    </pn-qr-code-generator>
                  )}
                </div>
                <div class="modal-content-list">
                  <ol>
                    {this.instructionPhoneLineOne && <li>{this.instructionPhoneLineOne}</li>}
                    {this.instructionPhoneLineTwo && <li>{this.instructionPhoneLineTwo}</li>}
                    {this.instructionPhoneLineThree && <li>{this.instructionPhoneLineThree}</li>}
                  </ol>
                </div>
              </div>
            )}
        </pn-modal>
      </Host>
    );
  }
}